import React from "react";
import { PaperProps } from "@mui/material";
import styles from "./styles";

const ITEM_HEIGHT = 48; // Constant for item height in menu
const ITEM_PADDING_TOP = 8; // Constant for top padding in menu

/**
 * Function to define menu attributes for Select component.
 * @param onScroll Function to handle scroll events.
 * @returns Object with PaperProps, styles, and autoFocus attributes.
 */
export const MenuAttributes = (onScroll: (evt: any) => void) => {
  return {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
      onScroll,
    } as PaperProps,
    sx: styles.select,
    autoFocus: false,
  };
};

/**
 * Function to get unique key for list item.
 * @param listItem List item object or string.
 * @param index Index of the list item.
 * @param valKey Key to access value in list item object.
 * @returns Unique key for the list item.
 */
export const GetKeyValue = (
  listItem: string | { [key: string]: any },
  index: number,
  valKey: string,
) => {
  if (typeof listItem === "string") return `row-${index + 1}`;
  return listItem[valKey];
};

/**
 * Function to get value from list item based on valKey.
 * @param listItem List item object or string.
 * @param valKey Key to access value in list item object.
 * @returns Value of the list item based on valKey.
 */
export const GetListValue = (
  listItem: string | { [key: string]: any },
  valKey: string,
) => {
  if (typeof listItem === "string") return listItem;
  return listItem[valKey];
};

/**
 * Function to get text to display from list item based on labelKey.
 * @param labelKey Key to access label text in list item object.
 * @param listItem List item object or string.
 * @returns Text to display from list item.
 */
export const GetListText = (
  labelKey: string,
  listItem: string | { [key: string]: any },
  isAccountPrimaryShow?: boolean,
) => {
  if (typeof listItem === "string") return <>{listItem}</>;

  if (!labelKey) return "";

  const label = listItem[labelKey];

  return (
    <>
      {label}
      {isAccountPrimaryShow && listItem.is_primary && (
        <>
          <strong style={{ color: "#e5063e", marginLeft: "4px" }}>
            (Primary)
          </strong>
        </>
      )}
    </>
  );
};
